export const platformVersion = '^17.2.0';
